<template>
    <div id="file-upload">
        <div v-if="!isSpecial">
            <div :class="`file-align-${align}`">
                <h3>{{ fieldLabelFile }}</h3>
                <div>
                    <div :class="['upload-container', { 'error': showError && isRequired && files.length === 0 }]">
                        <input type="file" :id="`file-input-${fieldId}`" class="file-input" @change="handleFileUpload" multiple>
                        <label :for="`file-input-${fieldId}`" class="file-label">
                            <div class="upload-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                     width="40px"
                                     height="40px">
                                    <path
                                        d="M12 4a4 4 0 0 1 3.87 3H17a4 4 0 0 1 0 8H7a4 4 0 0 1 0-8h1.13A4 4 0 0 1 12 4zm0 2a2 2 0 0 0-1.85 1.25L9.89 7.2 8 7.25a2 2 0 0 0-.21 4H17a2 2 0 0 0 .21-4H14.89L13.85 7.25A2 2 0 0 0 12 6zm0 6a1 1 0 0 1 .89 1.45L12 16l-.89-2.55A1 1 0 0 1 12 12zm-1-1.45L12 11l1 .55V14H11v-3.45z" />
                                </svg>
                            </div>
                            <p>{{ altLabelOne }}</p>
                        </label>
                    </div>
                    <p>{{ altLabelTwo }}</p>
                </div>

            </div>
            <div class="file-list">
                <div v-for="(file, index) in files" :key="index" class="file-item">
                    <img :src="file.preview" class="file-preview" />
                    <span class="file-name">{{ file.name }}</span>
                    <button class="delete-button" @click="removeFile(index)">Sil</button>
                </div>
            </div>
        </div>
        <div v-if="isSpecial" class="special-upload" @click="triggerFileInput">
            <img src="../../../SpecialForm/assets/btnLeft.svg" style="width: 200px" class="nano-img">
            <div class="label-overlay">
                <label v-if="files.length === 0">{{ localFieldLabelFile }}</label>
                <label v-else>Yüklendi...</label>
            </div>
            <input type="file" ref="specialFileInput" class="file-input" @change="handleSpecialFileUpload"
                   style="display: none">
        </div>
    </div>
</template>
<script>
import { uploadAsset } from "../../api/assetUpload";
import axios from "axios";

export default {
    name: "FormFileUpload",
    props: {
        fieldLabelFile: String,
        align: String,
        altLabelOne: String,
        altLabelTwo: String,
        value: {
            type: [Array, Object],
            default: () => [],
        },
        siteId: {
            type: String,
            required: true,
        },
        isRequired: {
            type: Boolean,
            default: false,
        },
        showError: {
            type: Boolean,
            default: false,
        },
        formId: {
            type: String,
            required: true,
        },
        order: {
            type: Number,
            required: true,
        },
        fieldId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            files: [],
            fileUrls: [],
            isSpecial: false,
            localFieldLabelFile: this.fieldLabelFile,
        };
    },
    watch: {
        fieldLabelFile(newVal) {
            this.localFieldLabelFile = newVal;
        },
    },
    methods: {
        triggerFileInput() {
            this.$refs.specialFileInput.click();
        },
        handleSpecialFileUpload(event) {
            const currentIndex = this.files.length;
            const newFiles = Array.from(event.target.files).map(file => ({
                name: file.name,
                preview: file.name.endsWith('.pdf') ? 'https://static.supsis.live/common/image/PDFICON.png' : URL.createObjectURL(file),
                raw: file,
                _id: null,
                fieldId: this.fieldId
            }));

            this.files = [...this.files, ...newFiles];

            newFiles.forEach((file, index) => {
                this.uploadFile(file.raw, currentIndex + index);
            });
        },
        handleFileUpload(event) {
            const currentIndex = this.files.length;
            const newFiles = Array.from(event.target.files).map(file => ({
                name: file.name,
                preview: file.name.endsWith('.pdf') ? 'https://static.supsis.live/common/image/PDFICON.png' : URL.createObjectURL(file),
                raw: file,
                _id: null,
                fieldId: this.fieldId
            }));

            this.files = [...this.files, ...newFiles];

            newFiles.forEach((file, index) => {
                this.uploadFile(file.raw, currentIndex + index);
            });
        },
        removeFile(index) {
            URL.revokeObjectURL(this.files[index].preview);
            this.fileUrls.splice(index, 1);
            this.files.splice(index, 1);
            this.emitValues();
        },
        async uploadFile(file, index) {
            console.log("siteId:", this.siteId);
            if (!this.siteId) {
                console.error("siteId cannot be null");
                return;
            }
            const path = `${this.siteId}/form/`;
            try {
                const imdUploadData = await uploadAsset({
                    path,
                    name: file.name,
                    size: file.size,
                    type: "form",
                    mime: file.type,
                    ext: file.name.split(".").pop(),
                });

                await axios({
                    method: imdUploadData.data.method,
                    url: imdUploadData.data.url,
                    data: file,
                    headers: {
                        "Content-Type": "application/octet-stream",
                        "site-id": this.siteId,
                    },
                });

                const assetId = imdUploadData.data.asset._id;
                const baseUrl = "static.supsis.live";
                const relativeUrl = `${baseUrl}/${imdUploadData.data.asset.path}${imdUploadData.data.asset._id}.${imdUploadData.data.asset.ext}`;

                if (assetId) {
                    this.files[index]._id = assetId;
                    this.fileUrls.push(relativeUrl);
                    this.emitValues();
                } else {
                    console.error("_id is null or undefined.");
                }

            } catch (e) {
                console.error(e);
            }
        },
        emitValues() {
            const values = Array.isArray(this.fileUrls) ?
                this.fileUrls :
                (this.fileUrls ? [this.fileUrls] : []);

            this.$emit("input", {
                fieldId: this.fieldId,
                values: values
            });

            this.$emit("validate", {
                fieldId: this.fieldId,
                hasError: this.isRequired && this.files.length === 0,
            });
        },
    },
    beforeDestroy() {
        this.files.forEach(file => {
            URL.revokeObjectURL(file.preview);
        });
    },
    mounted() {
        this.emitValues();
        const special = this.$route.query.special;
        if (special === "true") {
            this.isSpecial = true;
        }
    },
};
</script>
<style lang="scss" scoped>
.file-align-left {
    display: flex;
    align-items: center;
    padding: 10px;

    h3 {
        width: 150px !important;
        font-size: 14px !important;
        margin: 0;
    }
}

.file-align-right {
    display: flex;
    align-items: center;
    padding: 10px;

    h3 {
        width: 150px !important;
        font-size: 14px !important;
        text-align: right !important;
        margin-right: 5px !important;
        margin: 0;
    }
}

#file-upload {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    width: 100%;
    max-width: 600px;
    margin: auto;

    h3 {
        font-size: 18px;
        margin-bottom: 10px;
        text-align: left;
        width: 100%;
        margin: 0 auto 10px;
    }

    .upload-container {
        border: 1px dashed #d1d5db;
        padding: 20px;
        width: 100%;
        max-width: 400px;
        text-align: center;
        position: relative;
        background-color: #ffffff;
        border-radius: 4px;
        margin: 0 auto;

        .file-input {
            display: none;
        }

        .file-label {
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: pointer;

            .upload-icon {
                margin-bottom: 5px;
                width: 30px;
                height: 30px;
            }

            p {
                font-size: 14px;
                font-weight: 500;
                margin: 0;
                color: #374151;
            }

            span {
                font-size: 12px;
                color: #6b7280;
            }
        }
    }

    > div > p {
        margin-top: 5px;
        font-size: 12px;
        color: #6b7280;
        text-align: center;
    }

    .file-list {
        margin: 10px auto;
        width: 100%;
        max-width: 400px;

        .file-item {
            display: flex;
            align-items: center;
            margin-bottom: 5px;
            border: 1px solid #d1d5db;
            border-radius: 4px;
            padding: 5px;
            background-color: #ffffff;

            .file-preview {
                width: 40px;
                height: 40px;
                margin-right: 5px;
                object-fit: cover;
                border-radius: 4px;
                border: 1px solid #d1d5db;
            }

            .file-name {
                flex-grow: 1;
                font-size: 12px;
                color: #374151;
                max-width: 100px;
                overflow: hidden;
            }

            .delete-button {
                background: none;
                border: none;
                color: #e53e3e;
                font-size: 12px;
                cursor: pointer;
            }
        }
    }
}

.special-upload {
    position: relative;
    display: inline-block;
    width: 200px;
    height: 100px;
    text-align: center;
    cursor: pointer;
    margin: -30px;
    margin-left: -47px;
}

.nano-img {
    width: 100%;
    height: 80px;
    display: block;
}

.label-overlay {
    position: absolute;
    top: 20%;
    left: 58%;
    transform: translate(-50%, -50%);
    color: black;
    font-weight: bold;
    text-align: center;
    font-family: sans-serif;
    margin-top: 16px;
    width: 150px;
    font-size: small;
}

.upload-container.error {
    border-color: red !important;
}
</style>